import { styled } from "@mui/material/styles";

export const YAxisGroup = styled("g")(({ theme }) => ({
  fontSize: 12,
  color: theme.vars.palette.texts.neutral.subtle,
  "& > path": {
    display: "none",
  },
}));
